const requestingReportEmbedTokenType = 'REPORT_EMBEDTOKEN_REQUESTING';
const receivedReportEmbedTokenType = 'REPORT_EMBEDTOKEN_RECEIVED';

const initialState = { embedTokenResult: { reportId: "", embedUrl: "", accessToken: "" }, isLoading: true };


export const actionCreators = {
	requestingReportEmbedToken: (reportId) => async (dispatch, getState) => {

		dispatch({ type: requestingReportEmbedTokenType });

		try {
			const url = 'api/reports/embedtoken/' + reportId;
			const response = await fetch(url);
			const embedTokenResult = await response.json();

			dispatch({ type: receivedReportEmbedTokenType, embedTokenResult: embedTokenResult });
		}
		catch (e) { }
	}
};


export const reducer = (state, action) => {
	state = state || initialState;

	if (action.type === requestingReportEmbedTokenType) {
		return {
			...state,
			isLoading: true
		};
	}

	if (action.type === receivedReportEmbedTokenType) {
		return {
			...state,
			embedTokenResult: action.embedTokenResult,
			isLoading: false
		};
	}

	return state;
};


// WEBPACK FOOTER //
// ./src/store/ReportEmbedToken.js